<template>
	<div>
		<div id="background" v-bind:class="content[which].ScheduleExample.classes ? content[which].ScheduleExample.classes : ''">
			<div id="schedule-example-container">
				<div id="schedule-example-wrapper">
					<div id="close" v-on:click="closeScheduleExample([content[which].columnButtonAction,false])">
						<img width="24" src="../assets/global/close-button-alt.png" alt="close" />
					</div>
					<div id="schedule-example-content">
						<h3>
							<span>
								{{content[which].ScheduleExample.title}}
							</span>
							<sup v-html="content[which].ScheduleExample.title_sup"></sup>
						</h3>
						<nav>
							<ul>
								<li v-for="(tab,tabKey,index) in content[which].ScheduleExample.tabs" 
									v-bind:key="tabKey"  
									v-bind:class="index === activeTab ? 'active': ''"
									v-on:click="changeTab(index)"
								>
									{{tab.name}}
								</li>
							</ul>
						</nav>

						<div id="all-tabs">
							<div v-for="(tabContent,tabKey,idx) in content[which].ScheduleExample.tabs" 
									v-bind:key="tabKey" 
									class="tab-content"
									v-bind:class="idx === activeTab ? 'active': ''"
							>
								<div v-for="(panel,index_panel) in tabContent.panels" v-bind:key="index_panel"
									class="schedule-panel"
									v-bind:class="index_panel === activePanelImg[idx][0] ? 'active': ''"
								>
									<div v-if="!content[which].ScheduleExample.noArrows" class="schedule-example-arrow schedule-example-arrow-left"
										v-bind:class="index_panel === 1 ? 'active': ''"
										v-on:click="changeSchedule(0)"
									></div>
									<div v-if="!content[which].ScheduleExample.noArrows"  class="schedule-example-arrow schedule-example-arrow-right"
										v-bind:class="index_panel === 0 ? 'active': ''"
										v-on:click="changeSchedule(1)"
									></div>

									<div v-for="(img,index_key,index_img) in panel" 
									v-bind:key="index_img"
										class="schedule"
										v-bind:class="index_img === activePanelImg[idx][1] ? 'active': ''"
									>

										<div v-if="index_img === 0" v-on:click="expand(idx)" class="day"></div>
										<div v-if="index_img === 1" v-on:click="contract(idx)" class="day day-expanded"></div>


										<img v-bind:width="img" v-bind:src="require(`@/assets/${content[which].ScheduleExample.dirpath}/${which}/${tabType}/schedule_${idx}_${index_panel}_${index_img}.png`)" />
									</div>

								</div>
							</div>
						</div>


					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		which: {
			type: String
		},
		tabType: {
			type: String
		},
		content: {
			type: Object
		},
	},
	data() {
		return {
			activeTab: 0,
			activePanelImg: [ // 
				[
					0,0
				],
				[
					0,0
				],
				[
					0,0
				]
			]
		}
	},
	methods: {
		closeScheduleExample(whichActions){
			this.$emit('show-overlay',whichActions)
		},
		changeTab(index){
			this.activeTab = index
			this.activePanelImg = [
				[
					0,0
				],
				[
					0,0
				],
				[
					0,0
				]
			]
		},
		expand(tab){
			this.activePanelImg[tab][1] = 1
		},
		contract(tab){
			this.activePanelImg[tab][1] = 0
			
		},
		changeSchedule(which){
			this.activePanelImg[this.activeTab][0] = which
			this.activePanelImg[this.activeTab][1] = 0
		}
	},
	created(){
		//console.log(this.activePanelImg)
	}
}
</script>

<style scoped>
#background {
	background-color: rgba(228,231,234,.51);
	display: flex;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

#close {
	cursor: pointer;
	padding: 9px;
	position: absolute;
	top: 15px;
	right: 30px;
}

#schedule-example-container {
	font-family: Arial, Helvetica, sans-serif;
	display: grid;
	place-items: center;
	width: 100%;
	height: 100%;
}

	#schedule-example-wrapper {
		background-color: #fff;
		border-radius: 12px;
		width: 955px;
		padding: 26px 30px;
		min-height: 709px;
		position: relative;
	}

		.pre-initiation-pierce #schedule-example-wrapper {
			min-height: 564px;
		}

			h3 span,
			h3 sup {
				color: rgba(26,201,168);
			}

			h3 span {
				font-size: 2.1rem;
				line-height: 1;
			}

			h3 sup {
				font-size: 1.2rem;
				vertical-align: top;
				line-height: 1.3;
				padding-left: 1px;
			}


nav {
	margin: 15px 0 24px;
}

	nav ul,
	nav li {
		align-items: center;
		border-radius: 15px;
		display: flex;
		justify-content: center;
		min-height: 28px;
	}

	nav ul {
		background-color: #ebedf0;
	}

		nav ul li {
			color: #201545;
			cursor: pointer;
			flex-grow: 1;
			font-size: 1.6rem;
			transition: all 180ms ease-in-out;
		}

			nav ul li.active {
				background-color: #24b6a2;
				color: #fff;
			}

.tab-content {
	display: none;
}

.tab-content.active {
	display: block;
}

.main-img {
	position: relative;
}

	.main-img > div {
		position: absolute;
	}

		.schedule {
			position: relative;
		}

		.schedule-panel,
		.schedule {
			display: none;
		}

		.schedule-panel.active,
		.schedule.active {
			display: block;
		}


.schedule-example-arrow  {
	background-position: center center;
	background-repeat: no-repeat;
	background-size: contain;
	position: absolute;
	top: 50%;
	transform: translateY(-3px);
	width: 32px;
	height: 34px;
}

	.schedule-example-arrow-left {
		background-image: url(../assets/navigation/arrow-left-alt-off.png);
		left: -9px;
	}

		.schedule-example-arrow-left.active {
			background-image: url(../assets/navigation/arrow-left-alt-on.png);
			cursor: pointer;	
		}

	.schedule-example-arrow-right {
		background-image: url(../assets/navigation/arrow-right-alt-off.png);
		right: -9px;
	}

		.schedule-example-arrow-right.active {
			background-image: url(../assets/navigation/arrow-right-alt-on.png);	
			cursor: pointer;
		}

		.day {
			cursor: pointer;
			margin-top: 56px;
			position: absolute;
			width: 124px;
			height: 64px;
		}

		.day-expanded {
			width: 100%;
		}
</style>